<template lang="pug">
div.form
    div.row
        div.col-6.col-sm-2
            p.text.grey.phrase {{ $t("$form.phrase") }}
        div.col-6.col-sm-4.col-lg-3
            div.row
                text-input.col-6.col-sm-2(
                    v-model="formdata.name" :label="$t('$form.fields.name.label')"
                    :placeholder="$t('$form.fields.name.placeholder')"
                )
                text-input.col-6.col-sm-4(
                    v-model="formdata.contact" :label="$t('$form.fields.contact.label')" 
                    :placeholder="$t('$form.fields.contact.placeholder')"
                )
                file-input.col-6.col-sm-2(
                    v-model="formdata.photos.portrait" :label="$t('$form.fields.photos.label')" 
                    :placeholder="$t('$form.fields.photos.placeholder[0]')" extensions=".jpg, .jpeg, .png"
                )
                file-input.col-6.col-sm-2(
                    v-model="formdata.photos.fullGrowth" 
                    :placeholder="$t('$form.fields.photos.placeholder[1]')" extensions=".jpg, .jpeg, .png"
                )
                file-input.col-6.col-sm-2(
                    v-model="formdata.photos.side" 
                    :placeholder="$t('$form.fields.photos.placeholder[2]')" extensions=".jpg, .jpeg, .png"
                )
                textarea-input.col-6(
                    v-model="formdata.comment" :label="$t('$form.fields.comment.label')"
                    :placeholder="$t('$form.fields.comment.placeholder')"
                )
                div.col-auto.ml-auto
                    button.main(@click="sendData") {{ $t('$form.button') }}
</template>

<script>
import TextInput from '../inputs/TextInput.vue';
import FileInput from '../inputs/FileInput.vue';
import TextareaInput from '../inputs/TextareaInput.vue';
export default {
    name: 'user-form',
    data() {
        return {
            formdata: {
                name: "",
                contact: "",
                photos: {
                    portrait: "",
                    fullGrowth: "",
                    side: ""
                },
                comment: ""
            }
        }
    },
    methods: {
        sendData: function() {
            var formdata = new FormData();
            formdata.append('name', this.formdata.name);
            formdata.append('contact', this.formdata.contact);
            formdata.append('comment', this.formdata.comment);
            formdata.append('portrait', this.formdata.photos.portrait);
            formdata.append('fullGrowth', this.formdata.photos.fullGrowth);
            formdata.append('side', this.formdata.photos.side);
            this.$http.post("request", formdata).then(response => {
                console.log(response.body);
            })
            this.$emit("close");
        }
    },
    components: {
        'text-input': TextInput,
        'file-input': FileInput,
        'textarea-input': TextareaInput
    }
}
</script>

<style lang="scss" scoped>
@import '~styles/mixins.scss';
.phrase {
    max-width: 250px;
    margin-top: 25px;
}
.input {
    margin-bottom: 15px;
}
button {
    margin-top: 25px;
}
@media (max-width: grid-breakpoint(sm)) {
    .phrase {
        margin-top: 40px;
        padding-bottom: 25px;
    }
}
</style>




// WEBPACK FOOTER //
// UserForm.vue?22a8d476